import { CogoAgent } from "./CogoAgent"
import { AppV2 as AppV2Core } from "./App"
import type { AppV2Props } from "./App"

/**
 * Studio-facing renderer entrypoint. Published applications consume the
 * Agent-free core from `@cogo/react-renderer-v2/publishing` instead.
 */
export function AppV2({ agentSlot, manifest, ...props }: AppV2Props) {
  return (
    <AppV2Core
      {...props}
      manifest={manifest}
      agentSlot={agentSlot ?? (
        <CogoAgent
          appName={manifest.name}
          apiKey=""
          enabled={(manifest as any).agent?.enabled !== false}
        />
      )}
    />
  )
}

export type { AppV2Props } from "./App"
